'use client';

import React from 'react';

// PC端表格数据
const pcTableRows = [
  [
    'Deutschland/Österreich/Schweiz/ Belgien/Frankreich/Luxemburg',
    '10-22 Tage',
    '7.95 €',
    '6-11 Tage',
    '18.95 €',
  ],
  ['US', '10-22 Tage', '7.95 €', '6-11 Tage', '18.95 €'],
  ['Andere europäische Regionen', 'nicht verfügbar', '/', '7-14 Tage', '18.95 €'],
  ['andere Regionen', 'nicht verfügbar', '/', '7-14 Tage', '50.95 €'],
];

// PC端表格组件
const PCTable: React.FC = () => (
  <table className="w-full table-fixed border-separate border-spacing-0 border-collapse my-4 text-[14px] max-[959px]:text-[12px]">
    <colgroup>
      <col className="w-1/3 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
    </colgroup>
    <thead>
      <tr>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2" />
        <th className="h-[60px] border border-[#acc9fe] text-center py-2" colSpan={2}>
          Standardversand
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2" colSpan={2}>
          Business Express
        </th>
      </tr>
      <tr className="bg-[#d3e1fb]">
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">Länder</th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Voraussichtliche Lieferung
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Frais d&apos;expédition
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Voraussichtliche Lieferung
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Business-Express-Kosten
        </th>
      </tr>
    </thead>
    <tbody>
      {pcTableRows.map((row, i) => (
        <tr key={i}>
          {row.map((cell, j) => (
            <td key={j} className="h-[60px] border border-[#acc9fe] text-center py-2 break-words">
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

// 公共信息区块
const InfoSection: React.FC<{ isMobile?: boolean }> = ({ isMobile }) => (
  <>
    <h3
      className={
        isMobile
          ? 'text-[14px] font-bold mb-2 mt-6'
          : 'mt-[30px] text-[20px] font-bold font-sans max-[959px]:text-[14px] max-[959px]:mb-[10px]'
      }
      style={{ ...(isMobile && { fontFamily: 'bricolageGrotesqueBold' }) }}
    >
      Bemerkung:
    </h3>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Business Express nach Russland und Brasilien ist nicht verfügbar.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Aufgrund der Einschränkungen können wir keine Bestellungen aus dem Iran, dem Sudan, Syrien,
      Nordkorea, Hongkong China, Taiwan China, Usbekistan, Indien, Russische Föderation, Kuba,
      Brasilien, Französisch-Guayana, und Venezuela annehmen. Wir entschuldigen uns zutiefst für die
      Unannehmlichkeiten.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Von höherer Gewalt betroffen, kann sich die Lieferzeit aufgrund reduzierter internationaler
      Flüge verzögern. Empfehlen Sie Business Express zu wählen.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Das Standardversandkosten und das Business-Express-Kosten sind nur für die Sendungen innerhalb
      von 20 Paaren verfügbar.
    </p>
    <h3
      className={
        isMobile
          ? 'text-[14px] font-bold mb-2 mt-6'
          : 'mt-[30px] text-[20px] font-bold font-sans max-[959px]:text-[14px] max-[959px]:mb-[10px]'
      }
      style={{ ...(isMobile && { fontFamily: 'bricolageGrotesqueBold' }) }}
    >
      Kostenloser Standardversand ab 69€(DE/AT/BE/CH/US/FR/LU)
    </h3>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Kostenloser Versand über 69€(DE/AT/BE/CH/US/FR/LU)
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Der kostenlose Versand wird vor Versandkosten berechnet.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}Beschränkt auf Standardversand.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}Automatische Anwendung ohne Gutscheincode.
    </p>
    <h3
      className={
        isMobile
          ? 'text-[14px] font-bold mb-2 mt-6'
          : 'mt-[30px] mb-[20px] text-[20px] font-bold font-sans max-[959px]:text-[14px] max-[959px]:mb-[10px]'
      }
      style={{ ...(isMobile && { fontFamily: 'bricolageGrotesqueBold' }) }}
    >
      Sendungsverfolgung
    </h3>
    <p className="m-0 leading-[22px] text-[12px]">
      Sie können Ihr Paket direkt über die Option Sendungsverfolgung mit Ihrer E-Mail-Adresse
      verfolgen.
    </p>
  </>
);

// 移动端表格数据
const mobileStandardRows = [
  ['Deutschland/Österreich/Schweiz / Belgien/Frankreich/Luxemburg', '10-22 Tage', '7.95 €'],
  ['US', '10-22 Tage', '7.95 €'],
  ['Andere europäische Regionen', 'nicht verfügbar', '/'],
  ['andere Regionen', 'nicht verfügbar', '/'],
];

const mobileExpressRows = [
  ['Deutschland/Österreich/Schweiz/ Belgien/Frankreich/Luxemburg', '6-11 Tage', '18.95 €'],
  ['US', '6-11 Tage', '18.95 €'],
  ['Andere europäische Regionen', '7-14 Tage', '18.95 €'],
  ['andere Regionen', '7-14 Tage', '50.95 €'],
];

// 移动端表格组件
const MobileTable: React.FC<{
  title: string;
  head: string[];
  rows: string[][];
  style?: React.CSSProperties;
}> = ({ title, head, rows, style }) => (
  <table
    className="w-full table-fixed border-separate border-spacing-0 border-collapse my-4 text-[12px]"
    style={style}
  >
    <colgroup>
      <col className="w-5/10" />
      <col className="w-3/10" />
      <col className="w-2/10" />
    </colgroup>
    <tbody>
      <tr>
        <td className="border border-[#acc9fe] text-center py-2 font-bold" colSpan={3}>
          {title}
        </td>
      </tr>
      <tr className="bg-[#d3e1fb]">
        {head.map((h, i) => (
          <td key={i} className="border border-[#acc9fe] text-center py-2 font-bold">
            {h}
          </td>
        ))}
      </tr>
      {rows.map((row, i) => (
        <tr key={i}>
          {row.map((cell, j) => (
            <td key={j} className="border border-[#acc9fe] text-center py-2 break-words">
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

// 移动端子组件
const FRShippingTrackingMobile: React.FC = () => (
  <div className="w-full py-[5.333vw] px-[4.267vw] text-[12px] mb-10">
    <h1 className="text-center text-[24px] font-bold mb-2">
      <span>Versand&nbsp;&amp;&nbsp;Sendungsverfolgung</span>
    </h1>
    <div className="w-full">
      <MobileTable
        style={{ margin: '20px 0' }}
        title="Expédition Standard"
        head={['Länder', 'Voraussichtliche Lieferung', 'Standardver sandkosten']}
        rows={mobileStandardRows}
      />
      <MobileTable
        style={{ marginBottom: '20px' }}
        title="Business Express"
        head={['Länder', 'Voraussichtliche Lieferung', 'Business- Express- Kosten']}
        rows={mobileExpressRows}
      />
    </div>
    <InfoSection isMobile />
  </div>
);

// PC端子组件
const FRShippingTrackingPC: React.FC = () => (
  <div className="max-w-[1880px] px-[200px] my-[30px] mx-auto text-[14px] mb-[100px]">
    <h1 className="text-center text-[34px] font-bold font-sans max-[959px]:text-[24px]">
      <span>Versand&nbsp;&amp;&nbsp;Sendungsverfolgung</span>
    </h1>
    <br />
    <div className="w-full overflow-x-auto mt-[20px]">
      <PCTable />
    </div>
    <InfoSection isMobile={false} />
  </div>
);

// 主组件
const FRShippingTrackingClient: React.FC<{ isMobile: boolean }> = ({ isMobile }) => {
  return isMobile ? <FRShippingTrackingMobile /> : <FRShippingTrackingPC />;
};

export default FRShippingTrackingClient;
